export const TAP_IM_CLOSE_TRANSLATION_ID = 'tapImClose.plk';
export const TAP_IM_CLOSE_CASH_PAYMENT_TRANSLATION_ID = 'tapImCloseCashPayment.plk';
export const APPROX_MINUTES_AWAY_TRANSLATION_ID = 'approxMinutesAway.plk';
